// extracted by mini-css-extract-plugin
export default {"navigationButtonsContainer":"ZoneNavigation_navigationButtonsContainer__MUp4J","pagesSwitcher":"ZoneNavigation_pagesSwitcher__odDiH","peersTab":"ZoneNavigation_peersTab__Afv4s"};